
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1604124345884",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "6476",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M454.27451 283.915166A170.359344 170.359344 0 1 0 624.889956 454.27451a170.154462 170.154462 0 0 0-170.615446-170.359344zM908.60024 0H113.555822A113.914366 113.914366 0 0 0 0 113.555822v795.044418a113.914366 113.914366 0 0 0 113.555822 113.555822h795.044418a113.914366 113.914366 0 0 0 113.555822-113.555822V113.555822A113.914366 113.914366 0 0 0 908.60024 0z m-80.057623 908.60024l-217.533413-217.482193a283.966387 283.966387 0 1 1 127.180472-236.792317 282.737095 282.737095 0 0 1-47.122849 156.171269l217.482193 218.045618z m0 0",
        "p-id": "6477"
      }
    }
  ]
})
    }
  